const PENDING_REDIRECT_KEY = 'codes_pending_redirect';

const WORKSPACE_ONLY_ROUTES = ['/codes-keys', '/teams', '/my-page'];

export const savePendingRedirect = (url: string, forceOverwrite = false) => {
    if (!forceOverwrite && localStorage.getItem(PENDING_REDIRECT_KEY)) {return;}
    localStorage.setItem(PENDING_REDIRECT_KEY, url);
};

export const getPendingRedirect = (): string | null => {
    return localStorage.getItem(PENDING_REDIRECT_KEY);
};

export const clearPendingRedirect = () => {
    localStorage.removeItem(PENDING_REDIRECT_KEY);
};

export const buildWorkspaceRedirectUrl = (pendingUrl: string, workspaceId: string): string => {
    const needsPrefix = WORKSPACE_ONLY_ROUTES.some(
        route => pendingUrl === route || pendingUrl.startsWith(`${route}/`) || pendingUrl.startsWith(`${route}?`)
    );
    if (needsPrefix) {
        return `/w/${workspaceId}${pendingUrl}`;
    }
    return pendingUrl;
};

export const consumePendingRedirect = (workspaceId?: string): string | null => {
    const pending = getPendingRedirect();
    if (!pending) {return null;}

    clearPendingRedirect();
    return workspaceId ? buildWorkspaceRedirectUrl(pending, workspaceId) : pending;
};
